import "./balance.css";

export { default as BalanceGeneral } from "./BalanceGeneral";
